export const EMOJI_ICONS = [
  "微笑",
  "爱你",
  "拜拜",
  "悲伤",
  "鄙视",
  "闭嘴",
  "馋嘴",
  "吃惊",
  "鼓掌",
  "哈哈",
  "害羞",
  "黑线",
  "可爱",
  "可怜",
  "亲亲",
  "生病",
  "偷笑",
  "挖鼻",
  "委屈"
];



// WEBPACK FOOTER //
// ./src/assets/img/chat/images/emoji/emoji.js